import * as yup from 'yup';

export const validationSchema = (t: (trans: string) => string) =>
    yup.object({
        title: yup.string().required('Filter title is required'),
    });
